import { render } from "./tabs-history.vue?vue&type=template&id=c52b3f2c&ts=true"
import script from "./tabs-history.vue?vue&type=script&lang=ts"
export * from "./tabs-history.vue?vue&type=script&lang=ts"

import "./tabs-history.vue?vue&type=style&index=0&id=c52b3f2c&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__